import { render, staticRenderFns } from "./TenantHome.vue?vue&type=template&id=5c2aa2c0"
import script from "./TenantHome.vue?vue&type=script&lang=js"
export * from "./TenantHome.vue?vue&type=script&lang=js"
import style0 from "./TenantHome.vue?vue&type=style&index=0&id=5c2aa2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports